import { useGlobalLoader } from "vue-app/composables/useGlobalLoader";

export const roleCheckHook = (store) => (to, from, next) => {
  if (to.meta && to.meta.hasOwnProperty("requiredRoles")) {
    const userRoles = window.EDRONE_CONTEXT.user.roles;
    const isRoleFound = to.meta.requiredRoles.every((r) => userRoles[r]);
    if (isRoleFound) {
      next();
    } else {
      next({ path: `/app/access-denied?p=${to.meta.routeName}` });
    }
  } else {
    next();
  }
};

export const globalLoaderHook = () => (to, _, next) => {
  const { showGlobalLoader, hideGlobalLoader } = useGlobalLoader();
  to.meta.skipGlobalLoader ? hideGlobalLoader() : showGlobalLoader();

  next();
};

export const clearIntervals = (store) => (to, from, next) => {
  if (window.inboxMessagePing) {
    clearInterval(window.inboxMessagePing);
  }
  if (window.inboxConversationPing) {
    clearInterval(window.inboxConversationPing);
  }
  if (window.statisticsPing) {
    clearInterval(window.statisticsPing);
  }
  if (window.tickerTimer) {
    clearTimeout(window.tickerTimer);
  }
  next();
};
